export default __webpack_public_path__ + "static/media/init_no_record.a3db69c8.png";